<template>
    <a-modal v-model="show" :footer="null" centered :maskClosable="false" width="600px">
        <div slot="title">题目内容</div>
        <div class="edit-question">
            <div class="question-row">
                <div class="summary-label">填写方式</div>
                <div class="flex flex-center">
                    <a-radio-group v-model="params.required">
                        <a-radio :value="1">必填</a-radio>
                        <a-radio :value="0">选填</a-radio>
                    </a-radio-group>
                </div>
            </div>
            <div class="question-row">
                <a-select class="at-select q-type" v-model="params.type" @change="typeChange">
                    <a-select-option value="radio">单选题</a-select-option>
                    <a-select-option value="checkbox">多选题</a-select-option>
                    <a-select-option value="text">问答题</a-select-option>
                </a-select>
                <a-input v-model="params.title" class="at-input" placeholder="请输入题目" :maxLength="100" />
            </div>
            <div class="question-row">
                <div class="summary-label">题目描述</div>
                <a-textarea v-model="params.summary" class="at-input at-textarea" placeholder="请输入问题描述（可为空）"
                            :maxLength="200" autoSize></a-textarea>
            </div>
            
            <div class="ans-container" v-if="params.type === 'text'">
                <div class="question-row">
                    <div class="summary-label">上传图片</div>
                    <div class="flex flex-center">
                        <a-radio-group v-model="params.allow_images">
                            <a-radio :value="1">允许</a-radio>
                            <a-radio :value="0">不允许</a-radio>
                        </a-radio-group>
                    </div>
                </div>
                <div class="question-row" v-if="params.allow_images === 1">
                    <div class="summary-label">文本框状态</div>
                    <div class="flex flex-center">
                        <a-radio-group v-model="params.hide_text">
                            <a-radio :value="0">显示</a-radio>
                            <a-radio :value="1">隐藏</a-radio>
                        </a-radio-group>
                    </div>
                </div>
            </div>
            
            <div class="ans-container" v-else>
                <template v-for="(option, ok) in options">
                    <div class="q-item" :key="ok" v-if="!option.delete">
                        <span class="q-no">{{ getNo(ok) }}：</span>
                        <at-input class="q-input" v-model="option.title" placeholder="请输入答案内容" :maxLength="100">
                            <div class="a-del" @click="delOption(option, ok)">
                                <img src="/assets/images/question-del.png">
                            </div>
                        </at-input>
                    </div>
                </template>
            </div>
            
            <div class="btn-row">
                <div class="left">
                    <div class="btn" @click="addOption" v-if="params.type != 'text'">
                        <img src="/assets/images/question-add.png">
                        <span>添加选项</span>
                    </div>
                </div>
                <div class="right">
                    <div class="del" @click="delQuestion" v-if="params.id">删除</div>
                    <div class="save" @click="saveQuestion">保存</div>
                </div>
            </div>
        </div>
    </a-modal>
</template>
<script>
import api from "@/repo/api";
import AtInput from "@/components/AtInput.vue";

export default {
    name: "EditQuestion",
    components: {
        AtInput
    },
    props: {
        qa_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            show: false,
            // 选项字母序列
            nos: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            // 题目参数
            params: {
                title: "",
                type: "radio",
                summary: "",
                required: 1,
                allow_images: 0,
                hide_text: 0
            },
            options: [
                { title: "" },
                { title: "" },
                { title: "" },
            ],
            // 插入位置索引
            insertIndex: -1,
            editItem: null,
        }
    },
    methods: {
        init(question = {}) {
            console.log('init', question);
            if (question.id) {
                let item = { ...question };
                this.params = item;
                this.editItem = item;
                if (item.options && item.options.length) {
                    this.options = item.options;
                }
            } else {
                this.initData();
            }
            this.show = true;
        },
        insert(index) {
            this.initData();
            this.show = true;
            this.insertIndex = index;
        },
        typeChange() {
            if (this.params.type != 'text') {
                if (this.editItem) {
                    this.options = this.editItem.options || [];
                }
            }
        },
        addOption() {
            this.options.push({ title: '' });
        },
        delOption(option, index) {
            if (this.params.type != 'text') {
                if (this.options.filter(item => !item.delete).length <= 2) {
                    this.$message.error('选择题至少需要2个选项')
                    return
                }
            }
            if (option.id) {
                this.$set(option, 'delete', 1);
            } else {
                this.options.splice(index, 1);
            }
        },
        saveQuestion() {
            let params = {
                options: this.options,
                ...this.params,
            }
            if (this.qa_id) {
                params.qa_id = this.qa_id;
            }
            if (this.params.type == 'text') {
                params.options = [];
                // 确保数据类型为数字
                params.allow_images = this.params.allow_images ? 1 : 0;
                // 如果不允许上传图片，则强制将隐藏文本框设置为0（显示）
                params.hide_text = params.allow_images ? (this.params.hide_text ? 1 : 0) : 0;
            } else {
                // 如果切回选择题，清空这些属性避免脏数据
                params.allow_images = 0;
                params.hide_text = 0;
            }
            
            console.log('saveQuestion', params);
            this.$loading.show();
            api.post('/ast-qa/sync-question', params, res => {
                this.$loading.hide()
                if (res.code !== 0) return this.$message.error(res.msg || '保存失败');
                this.$message.success('保存成功');
                console.log('saveQuestion', res.data);
                if (this.params.id) {
                    this.$emit('fetchDetail');
                } else {
                    if (this.insertIndex == -1) {
                        this.$emit('fetchDetail');
                    } else {
                        this.$emit('insert', this.insertIndex, res.data);
                    }
                }
                this.show = false;
            })
        },
        delQuestion() {
            this.$confirm({
                title: "确定要删除这个题目吗？",
                onOk: () => {
                    let id = this.params.id;
                    this.$loading.show()
                    api.post('/ast-qa/delete-question', { id }, res => {
                        this.$loading.hide();
                        if (res.code !== 0) return this.$message.error(res.msg || '删除失败');
                        this.show = false;
                        this.$emit('delete', id);
                    })
                }
            })
        },
        initData() {
            this.params = {
                title: "",
                type: "radio",
                summary: "",
                required: 1,
                allow_images: 0,
                hide_text: 0
            };
            
            this.options = [
                { title: '' },
                { title: '' },
                { title: '' }
            ];
            
            this.insertIndex = -1;
            this.editItem = null;
        },
        getNo(qk) {
            let no = 0
            for (let i = 0; i < qk; i++) {
                if (this.options[i] && !this.options[i].delete) {
                    no++
                }
            }
            return this.nos[no] || (no + 1).toString()
        }
    },
}
</script>
<style scoped lang="less">
.btn-row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;

    .left {
        display: flex;
        align-items: center;

        .btn {
            width: 100px;
            height: 28px;
            background: #F7F7F7;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            margin-right: 12px;

            img {
                width: 16px;
                height: 16px;
                margin-right: 4px;
            }

            span {
                color: #333333;
                font-size: 14px;
            }
        }
    }

    .right {
        display: flex;
        align-items: center;
        cursor: pointer;
        .del {
            width: 80px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            color: #333333;
            border: 1px solid #333333;
            box-sizing: border-box;
            margin-right: 16px;
        }
        .save {
            width: 80px;
            height: 28px;
            line-height: 28px;
            background: #333333;
            color: #FFFFFF;
            text-align: center;
        }
    }
}

.question-row {
    width: 100%;
    display: flex;
    margin-bottom: 16px;
    
    &:last-child{
        margin-bottom: 0;
    }

    .at-select {
        width: 100px;
        margin-right: 8px;
    }

    .summary-label {
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #F7F7F7;
        margin-right: 8px;
    }

    .at-input {
        flex: 1;
    }

    .at-textarea {
        min-height: 60px;
    }
}



.q-type {
    background: #EEEEEE;
    border: 1px solid #EEEEEE;
    margin-right: 8px;

    /deep/ .ant-select-selection {
        background-color: transparent;
    }
}

.ans-container {
    margin-top: 24px;

    .q-item {
        display: flex;
        margin-top: 24px;

        .q-input {
            flex: 1;
        }

        .q-no {
            line-height: 40px;
            padding-right: 8px;
            font-size: 14px;
            color: #333333;
        }
    }
}

.a-del {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
        width: 16px;
        height: 16px;
    }
}

.answer-correct {
    width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    input {
        margin-right: 4px;
    }

    span {
        font-size: 14px;
        color: #333333;
    }
}

.qa-summary {
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    margin-top: 24px;

    .title {
        width: 78px;
        height: 40px;
        margin-right: 8px;
        line-height: 40px;
        background-color: #EEEEEE;
        border: 1px solid #EEEEEE;
        text-align: center;
    }

    .at-textarea {
        min-height: 51px;
        flex: 1;
    }
}
</style>